import React, { useState, useEffect } from "react";
import { Table, Checkbox } from "@veneer/core";
import Swal from "sweetalert2";
import ConnectAPI from "../../../services/api";

const connectApi = new ConnectAPI();

function SpecialConditionDetailTypes2_12({ specialCondition }) {
    const [specialBonusTable, setSpecialBonusTable] = useState([]);
    var fetchData;
    const epm = () => {
        if (specialCondition.idSpecialConditionType == 12 ||  specialCondition.idSpecialConditionType == 17) {
            return <Checkbox
                defaultChecked
                id="checkbox-checked"
                label="Includes EPM"
                disabled
            />
        }
        if (specialCondition.idSpecialConditionType == 15 || specialCondition.idSpecialConditionType == 17) {
            return <Checkbox
                defaultChecked
                id="checkbox-checked"
                label="Includes All Impresions"
                disabled
            />
        }
    }
    useEffect(() => {
        fetchData = async () => {
            connectApi.getWithParams("api/Channels/specialConditionsBonusTable", specialCondition.idSpecialCondition, getSCdataCallback)
                .catch((error) => {
                    Swal.fire(
                        "Error " + error?.response?.status,
                        error?.response?.data,
                        "error"
                    );
                });
        }
        fetchData();
    }, [specialCondition.idSpecialCondition]);

    let getSCdataCallback;
    getSCdataCallback = (status, data) => {
        if (data && data.length > 0) {
            data.forEach(item => {
                item.bonus = item.bonus + ' %';
                item.maxPrint=item.maxPrint.toLocaleString();
                item.minPrint=item.minPrint.toLocaleString();
            });
        }
        setSpecialBonusTable(data);
    }
    return (<>
        <Table id='BonusTable'
            columns={
                [
                    
                    {
                        id: 'minPrint',
                        label: 'Min Print',
                    },
                    {
                        id: 'maxPrint',
                        label: 'Max Print',
                    },
                    {
                        id: 'bonus',
                        label: 'Bonus',
                    },
                ]}
            data={specialBonusTable}
        >

        </Table>
        {epm()}
    </>);
}

export default SpecialConditionDetailTypes2_12;